import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCheckbox = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 9" {...props}>
    <path fill="none" d="m.192 4.688 3.431 3.103L10.405.297" />
  </svg>
);
const Memo = memo(SvgCheckbox);
export default Memo;
